const PASSWORD_POLICY = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

export const passwordRequirements = [
  'At least 8 characters',
  'One uppercase letter',
  'One lowercase letter',
  'One number',
  'One special character',
];

export function getPasswordValidationError(password: string, confirmPassword: string): string | null {
  if (!PASSWORD_POLICY.test(password)) {
    return 'Password must meet all listed requirements.';
  }

  if (password !== confirmPassword) {
    return 'Passwords do not match.';
  }

  return null;
}